<template>
    <div class="show-more">
        <VJoyButton
            :icon="icon"
            :label="label"
            :data-testid="testId"
            variant="ghost"
            :size="size ?? 'medium'"
            icon-position="right"
            @click="emits('click')"
        />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyButton, type TJoyButtonSizes} from '@maltjoy/core-vue';

    const props = defineProps<{
        collapsed: boolean;
        label?: string;
        testId: string;
        size?: TJoyButtonSizes;
    }>();

    const emits = defineEmits<{
        (e: 'click'): void;
    }>();

    const {t} = useTranslation();

    const icon = computed(() => (props.collapsed ? 'chevron-down' : 'chevron-up'));
    const label = computed(() => (props.collapsed ? (props.label ?? t('jstext.readmore.label.readmore')) : t('profile.section.show.less')));
</script>

<style lang="scss" scoped>
    .show-more {
        display: flex;
        justify-content: center;

        :deep(.joy-button--slot) {
            white-space: wrap;
        }
    }
</style>
